





















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import { lxReportClick } from '@/utils/directive/lxanaly';
import { OncallReportMap } from '@/config/lx.conf';

@Component
export default class ImportModal extends Vue {
    @Prop({ default: false })
    visible: boolean;
    @Prop({ default: null })
    timestamp: Date;
    @Prop({ default: 'WEEK' })
    type: 'WEEK' | 'MONTH';

    showModal: boolean = false;
    templateBtnLoading: boolean = false;
    submitBtnLoading: boolean = false;
    submitBtnDisabled: boolean = true;
    showValidateMsg: boolean = false;
    templateLink: string = '';
    fileLink: string = '';
    objectName: string = '';
    uploadHint: string = '';
    validateStatus: 'success' | 'error' = 'error';
    submitType: 'add' | 'override' = 'add';

    @Watch('visible', { immediate: true })
    onVisibleChanged() {
        this.showModal = this.visible;
    }
    cancel() {
        this.templateLink = '';
        this.$emit('update:visible', false);
    }
    async confirm() {
        this.submitBtnLoading = true;
        try {
            const res = await api.oncallApi.uploadOncallExcel(this.rgId, {
                file: this.fileLink,
                objectName: this.objectName,
                isOverride: this.submitType === 'override'
            });
            const { code } = res;
            if (code === 200) {
                this.submitBtnLoading = false;
                this.$mtd.message.success('导入值班表成功！');
                lxReportClick(OncallReportMap.submit_import_oncall);
                this.$emit('success');
                this.$emit('update:visible', false);
            }
        } catch (error) {
            this.submitBtnLoading = false;
            console.log(error);
        }
    }
    onTemplateBtnClick() {
        this.templateBtnLoading = true;
        this.generateTemplate();
    }
    async generateTemplate() {
        try {
            const res = await api.oncallApi.getOncallTemplate({
                rgId: [this.rgId],
                timestamp: this.timestamp.getTime(),
                timeType: this.type
            });
            const { data, code } = res;
            if (code === 200 && data) {
                this.templateLink = data.file;
                this.templateBtnLoading = false;
                window.open(this.templateLink, '_blank');
            }
        } catch (error) {
            this.templateBtnLoading = false;
            console.log(error);
        }
    }
    beforeUpload(file) {
        const isLtOneM = file.size / 1024 / 1024 < 1;
        if (!isLtOneM) {
            this.$mtd.message.error('上传文件大小不能超过 1MB');
        }
        return isLtOneM;
    }
    handleUploadSuccess(res) {
        this.fileLink = res.data.file;
        this.objectName = res.data.objectName;
        this.uploadHint = res.data.info || '校验成功！';
        this.validateStatus = this.fileLink ? 'success' : 'error';
        this.submitBtnDisabled = !this.fileLink;
        this.showValidateMsg = true;
    }
    handleUploadError() {
        this.$mtd.message.error('上传失败，请重试');
    }
    handleExceed() {
        this.$mtd.message.error('仅允许上传一个文件，请删除后重新上传');
    }
    handelFileRemove() {
        this.fileLink = '';
        this.objectName = '';
        this.showValidateMsg = false;
        this.submitBtnDisabled = true;
    }
    get btnText() {
        return this.templateBtnLoading ? '下载中...' : this.templateLink ? '下载值班表模板' : '生成值班表模板';
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
